import React, { useState, useEffect, useContext } from "react";
import "./style.scss";
import PrescriptionComponent from "../DoctorVideo/PrescriptionComponent";
import PastPrescription from "./PastPrescription";

export default function PrescriptionTabComponent(props) {
  const [activeTab, setActiveTab] = useState(1);

  const handleActiveTab = (val) => {
    setActiveTab(val);
  };

  const displayViewDocumentsTabs = () => {
    return (
      <div className="prescription-tabs-cont">
        <div
          className={
            "prescription-tabs " +
            (activeTab === 1 ? "prescription-tab-selected" : "")
          }
          onClick={() => handleActiveTab(1)}
        >
          Create Prescription
        </div>
        <div
          className={
            "prescription-tabs " +
            (activeTab === 2 ? "prescription-tab-selected" : "")
          }
          onClick={() => handleActiveTab(2)}
        >
          Past Prescriptions
        </div>
      </div>
    );
  };

  const displayViewDocumentsTabContents = () => {
    return (
      <div className="prescription-tab-content">
        {activeTab === 1 && (
          <div>
            <PrescriptionComponent
              appointmentData={props?.appointmentData}
              age={props?.age}
              fetchPastAppointmentDataList={props?.fetchPastAppointmentDataList}
              closeDrawer={props?.closeDrawer}
              drawerType={props?.drawerType}
              setDrowerPostionInitianlView={props?.setDrowerPostionInitianlView}
            />
          </div>
        )}
        {activeTab === 2 && (
          <div>
            <PastPrescription appointmentData={props?.appointmentData} />
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="prescription-cont">
      {displayViewDocumentsTabs()}
      {displayViewDocumentsTabContents()}
    </div>
  );
}
